/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 16:21:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 12:12:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/LegalCategory/slice/index.ts
 */
import {
  createSlice,
  //createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  //getSearchCondition as _getSearchCondition,
  //reducerTarget,
  getIsSearching as _getIsSearching,
  getSearch as _getSearch,
  getRequestSearch as _getRequestSearch,
  getData as _getData,
  getCollapse as _getCollapse,
  getLoaded as _getLoaded,
  getMoveList as _getMoveList,
  getRootUuid as _getRootUuid,
  getOrder as _getOrder,
} from 'src/pages/SalesChannelCategory/slice/common';
// import //searchConditions,
//   getStateTarget as getTarget,
// 'src/tools/helper';
import {
  getLegalCategories,
  postCategoryLegalSearch,
} from 'src/request/category';
import { onTagClose1 } from 'src/constrains/Query1/tools';
//import { generateDefaultCategory } from './common';
import { EnumReducers } from 'src/pages/SalesChannelCategory/slice/constants';
import { getState, dispatch } from 'src/store';
import {
  convertDataFromServerToReduxNoSearch,
  convertDataFromServerToReduxHasSearch,
} from 'src/pages/SalesChannelCategory/PagesCategory/tools';

//const getTarget = (state) => reducerTarget(state, [EnumReducers.legal]);

// const _isSearching = () => {
//   const state = getState();
//   const isSearching = getIsSearching()(state);

//   return { isSearching };
// };

const resetSearch = () => {
  dispatch(emptySearch());
};

function buildState({ state, data, searchingStatusHasChanged, isSearching }) {
  if (isSearching) {
    convertDataFromServerToReduxHasSearch({
      state,
      data,
      searchingStatusHasChanged, //因为发请求都取消search
    });
  } else {
    convertDataFromServerToReduxNoSearch({
      state,
      data,
      searchingStatusHasChanged,
    });
  }
}

export const fetchCategoriesLegal = createAsyncThunk(
  'fetchCategoriesLegal',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;

    const response = await getLegalCategories(uuid);
    return { response };
  },
);

export const postLegalSearch = createAsyncThunk(
  'postCategoryLegalSearch',
  async (params: { body }, thunkAPI) => {
    const { body } = params;
    const response = await postCategoryLegalSearch(body);
    return { response };
  },
);

const defaultState = {
  isEditing: false,
  search: [],
  //addNewCategoryList: [],
  ///currentEditing: {},
  dataSet: {}, //{uuid:data}
  loaded: false,
  collapseOpen: {},
  rootUuid: null,
  allNodesWithOrder: [], //所有的节点uuid
  order: [], //只有当前显示的顺序
};

const LegalCategory = createSlice({
  name: 'salesChannelLegalCategory',
  initialState: defaultState,
  reducers: {
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onSearchChange(state, action) {
      state.search.push(action.payload);
    },
    // onAddNewCategory(state, action) {
    //   const { salesChannelUuid } = action.payload;
    //   const _c = generateDefaultCategory({ salesChannelUuid });
    //   state.addNewCategoryList.push(_c);
    // },
    onSearchTagClose(state, action) {
      const { item } = action.payload;
      onTagClose1({ state, item, conditionKey: undefined });
    },
    onDataUpdate(state, action) {
      const isSearching = state.search.length > 0;

      if (isSearching) {
        state.search = [];
      }
      const { data } = action.payload;

      buildState({
        state,
        data,
        isSearching: false,
        searchingStatusHasChanged: isSearching,
      });
    },
    emptySearch(state) {
      if (state.search.length > 0) state.search = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoriesLegal.fulfilled, (state, action) => {
      //console.log('fetchCategoriesLegal');
      const { response } = action.payload;
      const isSearching = state.search.length > 0;
      if (isSearching) {
        resetSearch();
      } else {
        buildState({
          state,
          data: response,
          isSearching: false,
          searchingStatusHasChanged: isSearching,
        });
      }
    });

    builder.addCase(postLegalSearch.fulfilled, (state, action) => {
      const { response } = action.payload;
      const stillInSearching = state.search.length > 0;
      buildState({
        state,
        data: response,
        isSearching: stillInSearching,
        searchingStatusHasChanged: !stillInSearching,
      });
    });
  },
});

const getIsSearching = () => {
  return _getIsSearching(EnumReducers.legal);
};

const getLoaded = () => {
  return _getLoaded(EnumReducers.legal);
};

// const isEditing = () => {
//   return createSelector(
//     (state: any) => {
//       const isAdding = getTarget(state).addNewCategoryList.length < 1;
//       const isEditing = !!!Object.keys(getTarget(state).currentEditing).find(
//         (i) => i,
//       );
//       return isAdding && isEditing;
//     },
//     (enable) => {
//       return enable;
//     },
//   );
// };

const getSearch = () => {
  return _getSearch(EnumReducers.legal);
};

const getMoveList = (self) => {
  return _getMoveList(EnumReducers.legal, self);
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.legal, id);
};

const getContent = (id) => {
  return _getData(EnumReducers.legal, id);
};

const getRootUuid = () => {
  return _getRootUuid(EnumReducers.legal);
};

const getRequestSearch = () => {
  const state = getState();
  const search = _getRequestSearch(EnumReducers.legal)(state);
  return search;
};

const getOrder = () => {
  return _getOrder(EnumReducers.legal);
};

export const {
  onSearchChange,
  //onAddNewCategory,
  onSearchTagClose,
  emptySearch,
  onCollapseChange,
  onDataUpdate,
} = LegalCategory.actions;
export {
  getIsSearching,
  getSearch,
  getRequestSearch,
  //isEditing,
  getContent,
  getCollapse,
  getLoaded,
  getMoveList,
  getRootUuid,
  getOrder,
};

export default LegalCategory.reducer;
